import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

interface EmptyStateProps {
	icon?: LucideIcon;
	title: string;
	description?: string;
	action?: ReactNode;
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
	return (
		<div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
			{Icon && (
				<div className="grid size-14 place-items-center rounded-2xl border border-line bg-surface-2 text-brand">
					<Icon size={26} aria-hidden />
				</div>
			)}
			<h3 className="text-base font-semibold text-text">{title}</h3>
			{description && <p className="max-w-xs text-sm text-muted">{description}</p>}
			{action && <div className="mt-2">{action}</div>}
		</div>
	);
}
